import { VERSION, CHANNEL, BUILD_DATE } from './version';

export interface VersionUsageData {
  version: string;
  channel: string;
  timestamp: string;
  browser: string;
  domain: string;
  buildDate: string;
}

export async function reportVersionUsage(endpoint: string = 'https://api.fluxbotia.com/api/v1/widget/analytics/version'): Promise<void> {
  try {
    const usage: VersionUsageData = {
      version: VERSION,
      channel: CHANNEL,
      timestamp: new Date().toISOString(),
      browser: typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown',
      domain: typeof window !== 'undefined' ? window.location.hostname : 'unknown',
      buildDate: BUILD_DATE,
    };

    // Send to analytics asynchronously, don't block initialization
    fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(usage),
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
    }).catch((err) => {
      // Silently fail - telemetry shouldn't break widget
      if (typeof console !== 'undefined' && console.debug) {
        console.debug('[FluxBot Widget] Version reporting failed:', err.message);
      }
    });
  } catch (error) {
    // Silently fail - telemetry shouldn't break widget
    if (typeof console !== 'undefined' && console.debug) {
      console.debug('[FluxBot Widget] Version reporting error:', error);
    }
  }
}

export function initializeMonitoring(): void {
  // Report version usage on init
  if (typeof window !== 'undefined' && typeof fetch !== 'undefined') {
    // Use queueMicrotask to defer reporting
    if (typeof queueMicrotask !== 'undefined') {
      queueMicrotask(() => reportVersionUsage());
    } else {
      // Fallback for older browsers
      Promise.resolve().then(() => reportVersionUsage());
    }
  }
}
